<template>
  <div :class="[
    'main-container',
    { 'hole-page': isPage }
  ]">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'MainContainer',
  props: {
    /*
     * @property - isPage
     * Sets styles to cover window as hole page
     */
    isPage: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
  .main-container {
    padding: 1.5rem 0.75rem;
    margin-top: 3rem;
    overflow: auto;

    @include breakpoint($small) {
      margin-top: 3.25rem;
      flex: 1 0;
    }

    @include breakpoint($large) {
      margin-top: 3.75rem;
    }

    &.hole-page {
      @include breakpoint($small) {
        padding: 2rem 1.25rem;
      }
    }

    &:not(.hole-page) {
      @include breakpoint($small) {
        padding: 2rem 1.25rem 2rem 0;
      }
    }
  }
</style>
